// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import http from './http'
import guid from './guid.js'
import ElementUI from 'element-ui'
import VueProtoType from './vue-prototype'
import 'element-ui/lib/theme-chalk/index.css'
import i18n from './lang'

Vue.config.productionTip = false
VueProtoType({ Vue, http, guid, i18n })
Vue.use(ElementUI, {
  i18n: (key, value) => i18n.t(key, value)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js